export interface IServiceTaskCompletedData {
  workflowId: number;
  employeeId: number;
  employeeName: string;
  serviceLaneId: number;
  serviceLaneName: string;
  completingWorkerId: number;
  completingWorkerName: string;
  completedAt: string;
}

export function isServiceTaskCompletedData(data: unknown): data is IServiceTaskCompletedData {
  if (data == null || typeof data !== 'object') {
    return false;
  }

  const candidate = data as Partial<IServiceTaskCompletedData>;
  return (
    typeof candidate.workflowId === 'number' &&
    typeof candidate.employeeId === 'number' &&
    typeof candidate.employeeName === 'string' &&
    typeof candidate.serviceLaneId === 'number' &&
    typeof candidate.serviceLaneName === 'string' &&
    typeof candidate.completingWorkerId === 'number' &&
    typeof candidate.completingWorkerName === 'string' &&
    typeof candidate.completedAt === 'string'
  );
}
